import {LicensingResponse} from '../types/LicensingRequest';

import {post} from './Http';
import {logger} from './Logger';
import {ANALYTICS_LICENSECALL_TIMEOUT} from './Settings';
import {joinUrls} from './Utils';

export function LicenseCall(key: string, domain: string, version: string, baseUrl: string): Promise<LicensingResponse> {
  const licenseServerUrl = joinUrls(baseUrl, '/licensing');
  const licensingRequest = {
    analyticsVersion: version,
    domain,
    key,
  };
  return new Promise<LicensingResponse>((resolve, reject) => {
    // Safety net: reject the Promise if the callback is never invoked.
    // Http.post guarantees the callback is called on every completion path,
    // but this timeout protects against unforeseen edge cases (e.g., the XHR
    // silently hanging) that would leave the Promise — and with it the entire
    // analytics session — stuck forever.
    const timeout = setTimeout(() => {
      const message = 'License call POST request timed out';
      logger.error(message);
      reject(new Error(message));
    }, ANALYTICS_LICENSECALL_TIMEOUT);

    post(licenseServerUrl, licensingRequest, (error, response) => {
      clearTimeout(timeout);
      if (error) {
        reject(error);
        return;
      }
      resolve(response);
    });
  });
}
